import {IMuWidget} from "./IMuWidget";
import {getBaseCL} from "./Utils";
import {UiFlashMessage} from "./UiFlashMessage";
import {OrgRelatedAccountGroups} from "./CommonTypes";
import {TicketFormField} from "./TicketFormField";

export class AccountRoles extends TicketFormField
{
	public allowLeaveRole : boolean = false;

	public allowTakeRole : boolean = false;

	public allowDelegate : boolean = false;

	public useMainFlag : boolean = false;

	public loggedAccountId : number;

	afterIndex()
	{
		setTimeout(() => {
			this.ui.selected = this.ui.selectedContainer.getElementsByTagName('select')[0];
			if (!this.ui.selected) return;
			this.ui.cmd = this.container.querySelector('input[type="hidden"]');
			if (this.ui.selected)
			{
				// this.ui.selected.selectize.on('change', this.muGetMethodCallback('fillMainList'));
				this.ui.selected.selectize.on('change', () => {
					this.fillMainList();
					this.updateWidget();
				});
				if (this.useMainFlag)
				{
					const val = this.ui.mainId.value;
					this.fillMainList();
					if (val) this.ui.mainIdSelect.value = '.' + val;
					this.ui.mainId.value = val;
				}
			}
			this.updateWidget();
			// console.log(await getBaseCL().getUnderlings(6));
		}, 200);
	}

	public getSelected() : any[] {
		return this.ui.selected.selectize.getValue();
	}

	fillMainList()
	{
		if (!this.useMainFlag) return;
		var oldValue = this.ui.mainIdSelect.value;
		var ls = this.getSelected();
		for(var i = this.ui.mainIdSelect.options.length - 1 ; i >= 0 ; i--)
		{
			this.ui.mainIdSelect.remove(i);
		}
		var opt = document.createElement("option");
		opt.text = "Nevybrán";
		opt.value = "";
		this.ui.mainIdSelect.options.add(opt);

		for(var i = 0, l = ls.length; i < l; i++)
		{
			opt = document.createElement("option");
			opt.text = this.ui.selected.selectize.options[ls[i]].name.name;
			opt.value = ls[i];
			opt.selected = oldValue == opt.value;
			this.ui.mainIdSelect.options.add(opt);
		}
		this.mainIdSelect_change();
	}
	mainIdSelect_change()
	{
		this.ui.mainId.value = this.ui.mainIdSelect.value
			? this.ui.mainIdSelect.value.substr(1)
			: '';
	}
	callCmd(cmd: string, param: any = null) {
		this.ui.cmd.value = cmd + (param ? ":" + JSON.stringify(param) : "");
		this.ui.cmd.form.elements['btSubmit'].click();
	}
	bTake_click() {
		this.callCmd('take');
	}
	bLeave_click() {
		this.callCmd('leave');
	}

	private updateWidget() {
		const selected = this.getSelected();
		const min2 = selected.length > 1;
		const inSelected = selected.some(id => id.substr(1) == this.loggedAccountId.toString())
		if (this.allowLeaveRole) this.muVisible(min2 && inSelected, "bLeave");
		if (this.allowTakeRole) this.muVisible(min2 && inSelected, "bTake");
		if (this.allowDelegate) this.muVisible(inSelected, "bDelegate");
	}

	bDelegate_click() {
		getBaseCL().getOrgRelatedAccounts(this.loggedAccountId).then((data) => {
			// if (!data.length) UiFlashMessage.instance.add("Nemáte podřízené");
			this.muBindData(data);
		});
	}

	delegateTo(accountId: number) {
		this.callCmd('delegate', accountId);
	}

	bCloseUnderlings_click() {
		this.muVisible(false, "mUnderlings");
	}
}

export class AccountRolesUnderling extends IMuWidget {
	public accountId : number;
	name_click() {
		(this.muParent as AccountRoles).delegateTo(this.accountId)
	}
}
